import * as React from 'react';
import { Breadcrumb, Typography } from 'antd';
import SearchInput from './SearchInput/SearchInput.jsx';
import styles from './index.module.less';
import { FormattedMessage } from 'react-intl';
const { Title, Paragraph } = Typography;

export default function ImgContainer({
  onChangeKeyword,
  onChangeFlag,
  onChangeSelectedIndustry,
}) {
  return (
    <div className={styles.top_banner}>
      <Breadcrumb
        style={{
          borderBottom: '1px solid #f0f0f0',
        }}
        items={[
          {
            title: <FormattedMessage id="home" />,
          },
          {
            title: <FormattedMessage id="zhichi" />,
          },
          {
            title: <FormattedMessage id="ziyuan" />,
          },
        ]}
      />
      <Typography>
        <Title className={styles.title}><FormattedMessage id="ziyuan" /></Title>
        <Paragraph className={styles.description}>
        <FormattedMessage id="more" />

        </Paragraph>
      </Typography>
      <SearchInput
        onChangeKeyword={onChangeKeyword}
        onChangeFlag={onChangeFlag}
        onChangeSelectedIndustry={onChangeSelectedIndustry}
      />
    </div>
  );
}
